import React from 'react';
import { Utils, openModalForm } from '@kineticdata/bundle-common';
import {
  ACTION_FORM_TYPE,
  APPROVAL_FORM_TYPE,
  FORM_ATTR_EXCLUDE_REPORT_SITE_ISSUE,
  FORM_SLUG_REPORT_SITE_ISSUE,
  KAPP_SLUG_ERMS,
  PORTAL_PAGE_FORM_TYPE,
  REQUEST_FORM_TYPE,
  UTILITY_FORM_TYPE,
} from '../constants';

export const ReportSiteIssueWrapper = ({ form, reportForm, children }) =>
  reportForm &&
  form &&
  [
    REQUEST_FORM_TYPE,
    UTILITY_FORM_TYPE,
    APPROVAL_FORM_TYPE,
    ACTION_FORM_TYPE,
    PORTAL_PAGE_FORM_TYPE,
  ].includes(form.type) &&
  !Utils.hasAttributeValue(
    form,
    FORM_ATTR_EXCLUDE_REPORT_SITE_ISSUE,
    ['true'],
    true,
  ) ? (
    <>
      {children}
      <div className="report-site-issue-wrapper">
        <button
          className="btn btn-link"
          onClick={() =>
            openModalForm({
              kappSlug: KAPP_SLUG_ERMS,
              formSlug: FORM_SLUG_REPORT_SITE_ISSUE,
              values: { URL: window.location.href, 'Form Slug': form.slug },
              duration: 5000,
              title: 'Report an Issue With This Page or Service',
              confirmationMessage: 'Your issue has been submitted.',
            })
          }
        >
          Report an issue with this page or service
        </button>
      </div>
    </>
  ) : (
    children
  );
